import { Component, OnInit } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { HelpService } from "../help-service";

@Component({
  selector: "app-why-sukanda-onelink",
  templateUrl: "./why.component.html",
  styleUrls: ["./why.component.css"],
})
export class WhySukandaOneLinkComponent implements OnInit {
  constructor(
    private helpService: HelpService,
    public fb: FormBuilder,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {}

}
